import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Add debounce utility
export function debounce<F extends (...args: any[]) => any>(
  func: F,
  waitFor: number
): (...args: Parameters<F>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<F>): void => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => func(...args), waitFor);
  };
}

// Add sanitize utility for XSS prevention
export function sanitizeString(value: string | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  return value
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

// Add utility to protect against prototype pollution
export function safeObject(obj: Record<string, any>): Record<string, any> {
  const safeObj: Record<string, any> = {};
  
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && 
        key !== '__proto__' && 
        key !== 'constructor' && 
        key !== 'prototype') {
      safeObj[key] = obj[key];
    }
  }
  
  return safeObj;
}
